import React from 'react';

import { Box, Typography } from '@mui/material';
import classNames from 'classnames';
import styles from './MapHeader.module.scss';

interface Props {
  className?: string;
  heading: string;
  hasMapItems: boolean;
  loading: boolean;
  mapType: string;
}

const MapHeader: React.FC<Props> = ({ className, heading, hasMapItems, loading, mapType }) => (
  <Box
    className={classNames([
      styles.mapHeader,
      !(hasMapItems || loading) && styles.mapHeaderNoItems,
      mapType === 'windStations' ? styles.windStations : '',
      mapType === 'buoys' ? styles.buoys : '',
      className,
    ])}
  >
    <Typography variant="headline" component="h1" color="secondary" data-testid="map-header-title">
      {hasMapItems || loading ? heading : `No ${heading.toLocaleLowerCase()} found`}
    </Typography>
    <Typography
      variant="footnote"
      component="p"
      color="secondary"
      lineHeight="22px"
      data-testid="map-header-subtitle"
    >
      {hasMapItems || loading
        ? `Displaying all ${heading.toLocaleLowerCase()} in your map view, move the map to see more.`
        : 'Try zooming out or moving map.'}
    </Typography>
  </Box>
);

export default MapHeader;
